/**
 * Programmatic in-app navigation.
 *
 * The shell routes off `window.location.pathname` and listens for `popstate`.
 * `pushState` changes the URL without dispatching `popstate`, so the two must be
 * paired or the shell never re-renders. Keeping that pair in one place stops it
 * drifting — a caller that forgets the dispatch produces a URL change with no
 * visible navigation, which is confusing to debug.
 *
 * The current query string is carried across: it holds the signed login token,
 * which the auth flow re-reads on every load.
 *
 * A target that brings its own query wins on the params it names. That matters
 * for `tab`: linking to a shipment's Invoice tab has to set `?tab=invoice`
 * while keeping the token, and must not inherit whichever tab the previous page
 * happened to be on.
 */
export function navigateTo(path: string): void {
  const [pathname, targetQuery] = path.split("?");
  const params = new URLSearchParams(window.location.search);
  for (const [key, value] of new URLSearchParams(targetQuery ?? "")) {
    params.set(key, value);
  }
  const search = params.toString();
  window.history.pushState({}, "", search ? `${pathname}?${search}` : pathname);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
